<template>
  <div class="wrap">
    <div class="board">
      <div class="key_visual addImg inquiry">
        <div class="container">
          <p>서비스 이용 문의</p>
        </div>
      </div>
      <div class="board_contents">
        <div v-if="isDataLoaded" class="container">
          <div class="form_area">
            <form id="inquiry" @submit.prevent="checkDataInquiry">
              <table class="table_style_1 inquiry">
                <tbody>
                  <tr>
                    <th class="division">이름</th>
                    <td
                      class="division_nameNbelong set_two_th"
                      @click="focusInput"
                    >
                      <input
                        id="board_user_name"
                        v-model="inquiryName"
                        placeholder="이름을 입력해주세요."
                        type="text"
                        maxlength="20"
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        autocapitalize="off"
                        @input="validateName"
                      />
                    </td>
                    <th class="division">소속</th>
                    <td
                      class="division_nameNbelong set_two_th"
                      @click="focusInput"
                    >
                      <input
                        id="board_user_belong"
                        v-model="inquiryDepartment"
                        type="text"
                        placeholder="소속을 입력해주세요."
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        autocapitalize="off"
                      />
                    </td>
                  </tr>
                  <tr class="selectTr">
                    <th>문의 종류</th>
                    <td colspan="3" style="padding: 0 1rem">
                      <select
                        id="board_category"
                        v-model="inquiryCategory"
                        class="niceSelect"
                      >
                        <option value="" selected>
                          문의 내용을 선택해주세요.
                        </option>
                        <option
                          v-for="(item, index) in categoryData"
                          :key="index"
                          :value="item.code"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>E-mail</th>
                    <td colspan="3" @click="focusInput">
                      <input
                        id="board_mail"
                        v-model="inquiryEmail"
                        type="text"
                        placeholder="답변을 수신 받을 E-mail 주소를 작성해주세요."
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        autocapitalize="off"
                        @input="validateEmail"
                      />
                      <span class="board_mail_span"
                        >E-mail 형식이 올바르지 않습니다.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>전화번호</th>
                    <td colspan="3" @click="focusInput">
                      <input
                        id="board_phone"
                        v-model="inquiryPhone"
                        type="text"
                        placeholder="숫자만 입력 해주세요"
                        maxlength="13"
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        autocapitalize="off"
                        @input="formatPhoneNumber"
                      />
                      <span v-if="showPhoneWarning" class="board_phone_span">
                        전화번호를 모두 입력해주세요.
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>제목</th>
                    <td colspan="3" @click="focusInput">
                      <input
                        id="board_subject"
                        v-model="inquiryTitle"
                        type="text"
                        placeholder="50자 이내"
                        maxlength="50"
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        autocapitalize="off"
                      />
                      <span class="board_subject_span"
                        >제목을 작성해주세요.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>문의 내용</th>
                    <td colspan="3" @click="focusInput">
                      <textarea
                        id="board_txt"
                        v-model="inquiryTxt"
                        placeholder="문의 내용을 자세하게 작성해 주실수록 더욱 신속하게 답변 드릴 수 있습니다. "
                      ></textarea>
                      <span class="board_txt_span">
                        최소 10자 이상 입력이 필요합니다.
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>업로드</th>
                    <td colspan="3">
                      <div class="file_area">
                        <div
                          id="file_action"
                          class="btn_orange"
                          @click="openFileInput"
                        >
                          파일 불러오기
                        </div>
                        <span class="description">
                          * 오류 화면 캡쳐 이미지 등 상세 내용을 확인할 수 있는
                          파일을 첨부해 주시길 바랍니다.<br />
                          * 첨부 가능한 파일의 크기는 최대 10MB입니다.<br />
                        </span>
                        <input
                          id="up_file"
                          ref="fileInput"
                          type="file"
                          @change="addFile"
                        />
                      </div>
                      <div class="file_lists">
                        <div
                          v-for="(file, index) in selectedFiles"
                          :key="index"
                          class="list"
                        >
                          <p class="name">{{ file.name }}</p>
                          <img
                            class="list_remove"
                            src="/assets/images/icon/modal_close.png"
                            alt="Delete"
                            @click="deleteFile(index)"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table_style_1 inquiry">
                <tbody>
                  <tr>
                    <td class="privacyTbody" colspan="3">
                      <div class="privacy">
                        <div class="boldText">* 작성 전 확인해주세요!</div>
                        - 개인정보 수집, 이용에 동의하지 않을 권리가 있으며,
                        동의 거부 시 서비스 이용 문의 작성이 불가합니다.<br />
                        <br />
                        <div class="boldText">
                          [필수] 개인정보 수집, 이용에 관한 동의
                        </div>
                        - 개인정보 항목: 이름, 연락처, 이메일<br />
                        - 수집/이용 목적: 문의 대응<br />
                        - 보유 및 이용기간: 삭제 요청 또는 서비스 해지 시
                      </div>
                      <div class="check_area">
                        <input
                          id="board_privacy"
                          v-model="inquiryAgree"
                          type="checkbox"
                          class="ChekboldText"
                        />
                        <label
                          for="board_privacy"
                          class="board_privacy1"
                        ></label>
                        <label for="board_privacy" class="board_privacy2">
                          위 내용 확인했으며 동의합니다.
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div class="btn_area">
                <input
                  type="submit"
                  class="btn_orange gtm_inquiry"
                  value="문의 접수하기"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <ModalConfirm
        :confirmMsg="errMsg"
        :isOpen="errStatus"
        :sendCheck="checkSendData"
        @update:isOpen="updateStatus"
        :isitConfirm="openConfirm"
        @confirm="changeConfirmValue"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { loadInquiry, sendInquiry } from '../api/boards'
import ModalConfirm from '../components/ModalConfirm.vue'

export default {
  name: 'InquiryViews',
  components: {
    ModalConfirm,
  },
  setup() {
    const router = useRouter()

    const inquiryCategory = ref('')
    const inquiryName = ref('')
    const inquiryDepartment = ref('')
    const inquiryEmail = ref('')
    const inquiryPhone = ref('')
    const inquiryTitle = ref('')
    const inquiryTxt = ref('')
    const inquiryAgree = ref('')

    const categoryData = ref([])
    const isDataLoaded = ref(false)
    const selectedFiles = ref([])
    const errMsg = ref('')
    const errStatus = ref(false)

    const showInquiryTextWarning = ref(false)
    const inquiryTextWarningMessage = ref('')
    const checkSendData = ref('')
    const openConfirm = ref('alert')

    const updateStatus = () => {
      errStatus.value = false
    }

    // 이름 유효성 검사 (한글만 입력 가능)
    const validateName = (event) => {
      inquiryName.value = event.target.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣]/g, '')
    }

    // 이메일 입력 처리 (영어와 숫자만 입력 가능, 정상적인 이메일 형식 체크)
    const validateEmail = (event) => {
      inquiryEmail.value = event.target.value.replace(/[^a-zA-Z0-9@.]/g, '')
    }
    // 이메일 형식 검사
    const isValidEmail = (email) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
      return emailRegex.test(email)
    }
    const showPhoneWarning = ref(false)
    // 전화번호 형식화 (숫자만 입력 가능, 하이픈 자동 추가)
    const formatPhoneNumber = (event) => {
      let phoneNumber = event.target.value.replace(/[^0-9]/g, '')
      if (phoneNumber.length > 3 && phoneNumber.length <= 7) {
        phoneNumber = phoneNumber.replace(/(\d{3})(\d+)/, '$1-$2')
      } else if (phoneNumber.length > 7) {
        phoneNumber = phoneNumber.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3')
      }
      inquiryPhone.value = phoneNumber

      // 전화번호 길이 체크
      showPhoneWarning.value = phoneNumber.length > 0 && phoneNumber.length < 13
    }
    const changeConfirmValue = async () => {
      if (selectedFiles.value && selectedFiles.value.length > 0) {
        const sendFile = selectedFiles.value[0]
        const reader = new FileReader()
        reader.onload = async () => {
          await sendInquiry(
            inquiryCategory.value,
            inquiryName.value,
            inquiryDepartment.value,
            inquiryEmail.value,
            inquiryPhone.value,
            inquiryTitle.value,
            inquiryTxt.value,
            sendFile
          )
        }
        reader.readAsDataURL(sendFile)
      } else {
        await sendInquiry(
          inquiryCategory.value,
          inquiryName.value,
          inquiryDepartment.value,
          inquiryEmail.value,
          inquiryPhone.value,
          inquiryTitle.value,
          inquiryTxt.value,
          null
        )
      }
      errStatus.value = false
      router.push({ name: 'InquiryCompleteViews' })
    }
    const getData = async () => {
      const response = await loadInquiry()
      categoryData.value = response.data.content
      isDataLoaded.value = true
    }

    const fileInput = ref(null) // ref 추가
    const openFileInput = () => {
      if (fileInput.value) {
        fileInput.value.value = '' // 이전 선택값 초기화
        fileInput.value.click()
      }
    }
    const addFile = (event) => {
      // 파일 선택 이벤트 처리
      const selectedFile = event.target.files?.[0] // 첫 번째 파일만 가져오기
      // 파일 선택 취소한 경우
      if (!selectedFile) {
        return
      }
      // 파일 크기 체크 (10MB)
      if (selectedFile.size > 10 * 1024 * 1024) {
        errStatus.value = true
        errMsg.value =
          '첨부 파일의 용량이 10MB를 초과하여 업로드할 수 없습니다.<br>파일 용량를 줄여 주세요.'
        checkSendData.value = 'yet'
        // eslint-disable-next-line no-param-reassign
        event.target.value = '' // input 초기화
        selectedFiles.value = [] // 선택된 파일 목록 초기화
        return
      }
      // 유효한 파일인 경우 선택된 파일 목록에 추가
      selectedFiles.value = [selectedFile]
    }
    const deleteFile = (index) => {
      selectedFiles.value.splice(index, 1) // 선택된 파일 목록에서 해당 인덱스의 파일 삭제
    }
    const checkDataInquiry = () => {
      if (!inquiryName.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = '이름을 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryDepartment.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = '소속을 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryCategory.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = '문의 종류를 선택해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryEmail.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = 'E-mail을 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!isValidEmail(inquiryEmail.value)) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = '올바른 E-mail 형식을 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryPhone.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = '전화번호를 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryTitle.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value = '문의 하실 사항의 제목을 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryTxt.value || inquiryTxt.value.trim() === '') {
        errStatus.value = true
        errMsg.value = '문의 하실 사항의 내용을 입력해주세요.'
        checkSendData.value = 'yet'
      } else if (!inquiryAgree.value) {
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        errMsg.value =
          '개인정보 수집 및 이용에 관한 동의를 하셔야<br>문의 접수가 가능합니다.'
        checkSendData.value = 'yet'
      } else {
        errMsg.value = '작성하신 서비스 이용 문의 내용을 접수하시겠습니까?'
        errStatus.value = true // 모달을 열도록 errStatus 업데이트
        openConfirm.value = 'confirm' // Confirm 이 열리도록 체크
        checkSendData.value = 'sendData'
      }
    }

    // input으로 포커싱해주기
    const focusInput = (event) => {
      const input = event.currentTarget.querySelector('input, textarea')
      if (input) {
        input.focus()
      }
    }

    onMounted(() => {
      getData()
    })
    return {
      inquiryCategory,
      inquiryName,
      inquiryDepartment,
      inquiryEmail,
      inquiryPhone,
      inquiryTitle,
      inquiryTxt,
      inquiryAgree,

      categoryData,
      isDataLoaded,

      errMsg,
      errStatus,
      openConfirm,
      checkSendData,
      updateStatus,
      changeConfirmValue,

      selectedFiles,
      addFile,
      openFileInput,
      deleteFile,
      checkDataInquiry,

      validateName,
      validateEmail,
      isValidEmail,
      showPhoneWarning,
      formatPhoneNumber,
      alignLeft: 'text-align: left;',

      showInquiryTextWarning,
      inquiryTextWarningMessage,
      focusInput,
    }
  },
}
</script>
